import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Food & Inventory',
  icon: 'mdi-clipboard-outline',
  path: '/reports/controls/',
  ...addPermissionsToRoute(['mtFood']),
  children: [
    {
      path: '/reports/controls/foodDashboard',
      meta: { id: 'reports-mtControlsFoodDashboard' },
      name: 'Food At A Glance',
      component: () => import('./dashboard/FoodDashboard.vue'),
    },
    {
      path: '/reports/controls/inventoryVariance',
      meta: { id: 'reports-mtControlsInventoryVariance' },
      name: 'Inventory Variance',
      component: () => import('./InventoryVariance.vue'),
    },
    {
      path: '/reports/controls/usageFoodCost',
      meta: { id: 'reports-mtControlsUsageFoodCost' },
      name: 'Food Cost',
      component: () => import('./UsageFoodCost.vue'),
    },
    {
      path: '/reports/controls/foodOverBase',
      meta: { id: 'reports-fob' },
      name: 'Food Over Base',
      component: () => import('./FoodOverBase.vue'),
    },
    {
      path: '/reports/controls/wasteVariance',
      meta: { id: 'reports-mtControlsWasteVariance' },
      name: 'Waste Variance',
      component: () => import('./WasteVariance.vue'),
    },
  ],
};

export default routes;
